export default __webpack_public_path__ + "static/media/troy-Leela-Error 1.d48321a4.png";